module.exports = __webpack_public_path__ + "img/logofurore.4b6dd6fc.svg";